<template>
  <div class="personal-data">
    <div class="list">
      <div
        class="item acea-row row-between-wrapper"
        v-if="userInfo.certification_type > 2"
      >
        <div class="title">下級統一扣率</div>
        <div class="input acea-row row-between-wrapper">
          <div class="input acea-row row-between-wrapper">
            <input
              type="number"
              v-model="userInfo.brokerage_config"
              class="config"
            />
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="title">本級扣率</div>
        <div class="input acea-row row-between-wrapper">
          <div class="input acea-row row-between-wrapper">
            <input
              type="number"
              :value="userInfo.brokerage"
              class="id"
              disabled
            /><span class="iconfont icon-suozi"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit">保存修改</div>
  </div>
</template>
<script>
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import { postUserEdit, getUser } from "@api/user";

export default {
  name: "PersonalData",
  components: {},
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      avatar: "",
      isWeixin: false,
      currentAccounts: 0,
      userIndex: 0,
      userInfo: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    }
  },
  mounted: function() {
    this.avatar = this.userInfo.avatar;
    this.isWeixin = isWeixin();
    this.getUserInfo();
  },
  methods: {
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },

    submit: function() {
      postUserEdit({
        nickname: trim(this.userInfo.nickname),
        avatar: this.userInfo.avatar,
        brokerage_config: trim(this.userInfo.brokerage_config)
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$message.success(res.msg);
          this.$router.push({
            path: "/home"
          });
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.personal-data
  .list
    .item
      font-size 16px
      display flex
      align-items center
      margin 4px
      .title
        width 100px
        text-align right
      input
        margin-left 20px
        border 1px black solid
        padding 2px 4px
        border-radius 4px
  .modifyBnt
    width 120px
    text-align center
    padding 4px 0
    box-sizing border-box
    border-radius 14px
    background-color red
    color white
    cursor pointer
    margin 50px 0 0 100px
</style>
